import { render, staticRenderFns } from "./XButton.vue?vue&type=template&id=7fa08a9a&scoped=true&"
import script from "./XButton.vue?vue&type=script&lang=js&"
export * from "./XButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa08a9a",
  null
  
)

export default component.exports